const map = {
	"./en-GB.json": [
		40454,
		[
			454
		]
	],
	"./es-ES.json": [
		19702,
		[
			702
		]
	],
	"./pt-BR.json": [
		82118,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map((id) => (__webpack_require__.e(id)))).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4726;
module.exports = webpackAsyncContext;